import api from '../../api'
import { InvoicingProgressData } from './progressModel'

export const getInvoicingProgress = async () => {
  const response = await api.get<InvoicingProgressData>('/web/admin/invoicing-progress')
  return response.data
}
